export class LocationService {
    constructor() {
        this.locationChangeCallback = null;
        this.userCurrentLocation = null;
        this.userCurrentLocationText = null;
    }

    isUserCurrentLocation() {
        return !!this.userCurrentLocation;
    }

    setLocation(location, text, blockSearchNearbyStores, source = "search") {
        const { lat, lng } = location;
        if (lat && lng) {
            const newLocation = { lat, lng, source };
            this.userCurrentLocation = newLocation;
            this.locationChangeCallback(newLocation, blockSearchNearbyStores);
            if (text) {
                this.userCurrentLocationText = text;
                newLocation.description = text;
            }
        }
    }

    getLocation() {
        return this.userCurrentLocation;
    }

    getLocationText() {
        return this.userCurrentLocationText;
    }

    resetLocation() {
        this.userCurrentLocation = null;
        if (this.locationResetCallback) {
            this.locationResetCallback();
        }
    }

    onLocationChange(callback) {
        if (this.locationChangeCallback) throw new Error("location change callback already registered");
        this.locationChangeCallback = callback;
    }

    onLocationReset(callback) {
        if (this.locationResetCallback) throw new Error("location reset callback already registered");
        this.locationResetCallback = callback;
    }
}

const locationService = new LocationService();
export default locationService;
